'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.formular = twentyninetimes.formular || function () {

	function init() {
    var formular_inputs = document.querySelectorAll('.customform-field input, .customform-field textarea, .customform-field select');
		if ( formular_inputs.length > 0 ) {
			formLabelToggle(formular_inputs);
		}

    var fileInputs = document.querySelectorAll('input[type="file"]');
    if ( fileInputs.length > 0 ) {
      fileInputs.forEach((input) => {
        input.addEventListener("change", handleFileSelect, false);
      });
    }

    var forms = document.querySelectorAll(".customform-form");
    if ( forms.length > 0 ) {
      forms.forEach((form) => {
        form.addEventListener("submit", function (e) {
          e.target.classList.add("sending");
        });
      });
    }
	}

  function formLabelToggle(inputs) {
    inputs.forEach((input) => {
        input.addEventListener('input', (e) => {
            e.stopPropagation();

            var value = input.value,
                field = input.parentNode;

            ( !value == '' )
                ? field.classList.add('has-value')
                : field.classList.remove('has-value');
        });
    });
  }

  function handleFileSelect(evt) {
    var target = evt.target,
      files = target.files,
      list = target.parentNode.parentNode.querySelector(
        ".customform-field-file__list"
      ); // FileList object

    if (list) {
      target.parentNode.parentNode.removeChild(list);
    }

    if (files) {
      list = document.createElement("ul");
      list.setAttribute("class", "customform-field-file__list");
      target.parentNode.parentNode.appendChild(list);
    }

    // Loop through the FileList and render image files as thumbnails.
    for (var i = 0, f; (f = files[i]); i++) {
      let type = f.type;
      // Only process image files.
      // if (!f.type.match('image.*')) {
      //   continue;
      // }

      var reader = new FileReader();

      // Closure to capture the file information.
      reader.onload = (function (theFile) {
        return function (e) {
          // Render thumbnail.
          var span = document.createElement("li"),
            html = type.match("image.*")
              ? [
                  '<figure class="image"><img src="',
                  e.target.result,
                  '" title="',
                  theFile.name,
                  '"/></figure><span>',
                  theFile.name,
                  "</span>",
                ]
              : [
                  '<figure class="file"></figure>',
                  '<span>',theFile.name,'</span>'
                ];

          span.innerHTML = html.join("");
          list.appendChild(span, null);
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsDataURL(f);
    }
  }

  return {
		init : init
	};

}();